import { Configuration } from "../../../models";

export const configurationAppMapper = (configuration: Configuration) => {
  return {
    environment: configuration.environment,
    firebaseVapidKey: configuration.firebaseVapidKey,
    modules: {
      icnea: configuration.modules?.icnea ?? false,
      rentalready: configuration.modules?.rentalready ?? false,
      hostaway: configuration.modules?.hostaway ?? false,
    },
  };
};
